import { FC } from 'react';
import classNames from 'classnames';
import { IMultiLanguageInputPlaceholderProps } from '../../types';
import { LOCALES } from 'src/constants/main';

const MultiLanguageInputPlaceholder: FC<IMultiLanguageInputPlaceholderProps> = ({
  placeholder,
  currentLanguage,
  enValue,
  arValue,
  placeholderClassName,
}: IMultiLanguageInputPlaceholderProps): JSX.Element | null => {
  if (!placeholder || (currentLanguage === LOCALES.EN && enValue) || (currentLanguage === LOCALES.AR && arValue)) return null;

  return <span className={classNames('multi-lng-input__placeholder', placeholderClassName)}>{placeholder}</span>;
};

export default MultiLanguageInputPlaceholder;
